export default __webpack_public_path__ + "static/earn-recognition-illustration-dark-a1eb426a1c5530747cfe27e9d3164927.svg";